import { AfterViewInit, Component, Input, Output, OnChanges, SimpleChanges, EventEmitter, ChangeDetectorRef, AfterViewChecked, AfterContentChecked } from '@angular/core';
import * as _ from 'lodash';
import { NgIf, NgTemplateOutlet, NgFor, NgStyle, NgClass } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../ltms-loader/ltms-loader.component';
import { LtmsTooltipDirective } from '../../../../ltms-tooltip/ltms-tooltip.directive';
import { getDeviationTooltipText, getPositiveDeviationValue } from 'src/app/shared/utils/score-deviation.util';
@Component({
    selector: 'app-overview-table',
    templateUrl: './overview-table.component.html',
    styleUrls: ['./overview-table.component.scss', './overview-table-theme.scss'],
    imports: [NgIf, NgTemplateOutlet, LtmsLoaderComponent, NgFor, NgStyle, NgClass, LtmsTooltipDirective]
})
export class OverviewTableComponent implements OnChanges, AfterViewInit, AfterViewChecked {
  @Input() config: any = [];
  @Input() columns: any = [];
  @Input() fixedColumns: any = [];
  @Input() rows: any = [];
  @Input() type: string = 'default';
  @Input() selectedRow: any = {};
  @Input() showDeviation: boolean = false;
  @Input() deviationComparisonLabel: string = '';
  @Output() onDrillDown: any = new EventEmitter<any>();
  @Output() onSelect: any = new EventEmitter<any>();
  @Output() onExapnd: any = new EventEmitter<any>();
  @Output() onCheck: any = new EventEmitter<any>();
  @Output() onEdit: any = new EventEmitter<any>();
  @Output() delete: any = new EventEmitter<any>();
  @Output() onDataSort: any = new EventEmitter<any>();
  isFixedColumnAvailable: boolean = false;
  tableType: string = 'default'
  sortColumn: any = null;
  sortTable: any = null;
  sortDirection: string = 'asc'
  tableColumns: any = [];
  fixedTableColumns: any = [];
  tableRows: any = []
  tableConfig: any = {
    showHeatMap: false,
    hideText: false,
    showCheckbox: false
  }
  tableStyle: any = {}
  scrollSyncronizeId: any = null;
  selecterRowKey: any = null;
  isRendringComplete: boolean = false
  defaultSortOnColumn:any = null;
  isExternalSort:boolean = false;
  isRenderdingCompleted:boolean = false
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.isRendringComplete = false;
    if (changes && changes['columns']) {
      this.tableColumns = this.columns;
    }

    if (changes && changes['type'] && this.type != '') {
      if (this.type == 'drilldown' || this.type == 'accordion') {
        this.tableType = this.type;
      } else {
        this.tableType = 'default';
      }

    }

    if (changes && changes['selectedRow'] && !_.isEmpty(this.selectedRow)) {
      this.selecterRowKey = this.selectedRow.key;
    }

    if (changes && changes['fixedColumns']) {
      this.fixedTableColumns = this.fixedColumns;
      if (this.fixedColumns && this.fixedColumns.length) {
        this.isFixedColumnAvailable = true;
      } else {
        this.isFixedColumnAvailable = false;
      }

    }

    if (changes && changes['rows']) {
      this.tableRows = this.rows;
      
      // this.blinkColumn = null;
    }
    if (changes && changes['config']) {
      this.tableConfig = this.config;
      this.scrollSyncronizeId = _.get(this.config, 'scrollSyncronizeId', null);
      this.defaultSortOnColumn = _.get(this.config, 'defaultSortOnColumn', null);
      this.isExternalSort = _.get(this.config, 'isExternalSort', null);
      this.tableStyle = (this.config && this.config.style) ? this.config.style : {}
    }
    if(this.defaultSortOnColumn && this.defaultSortOnColumn.uniqueId){
      this.sortColumn = this.defaultSortOnColumn.sortId || this.defaultSortOnColumn.uniqueId;
      this.sortTable = 'parent';
      this.sortDirection = (this.defaultSortOnColumn.sort_order)?this.defaultSortOnColumn.sort_order:'asc'
      this.sortData(this.tableRows)
    }else{
      this.sortColumn = null;
      this.sortTable = null;
      this.sortDirection = 'asc';
    }
  }

  rowHeights: any = {}
  ngAfterViewInit(): void {
    if (this.scrollSyncronizeId && this.scrollSyncronizeId != '') {
      const elms = document.querySelectorAll('.' + this.scrollSyncronizeId);
      if (elms && elms.length) {
        elms.forEach((el: any) => {
          if (el) {
            el.addEventListener('scroll', (event: any) => {
              elms.forEach((scrollEL: any) => {
                if (scrollEL != event.target) {
                  scrollEL.scrollLeft = event.target.scrollLeft
                }
              })
            })
          }
        })
      }
    }


    this.cdr.detectChanges();
  }

  ngAfterViewChecked(): void {
    if (!this.isRendringComplete && this.isFixedColumnAvailable && this.rows && this.rows.length) {

      let rowHeightsObj: any = {}
      setTimeout(() => {
        _.each(this.rows, (row: any) => {
          const row1: any = document.querySelector('.fixed-column-table>.data-table >tbody > #row_' + row.key);
          const row2: any = document.querySelector('.scrollable-column-table>.data-table >tbody > #row_' + row.key);
          const cells: any = document.querySelectorAll('.data-table >tbody > #row_' + row.key + ">td>.cell-wrapper");
          if (cells && cells.length) {
            let cellMaxHieght: number = 0;
            cells.forEach((cell: any) => {
              const cellRect: any = cell.getBoundingClientRect();
              if (cellMaxHieght < cellRect.height) {
                cellMaxHieght = cellRect.height
              }
            })
            rowHeightsObj[row.key] = cellMaxHieght + 'px'
          }
          this.rowHeights = rowHeightsObj
        })
        this.isRendringComplete = true
      }, 500)

    }
    if (!this.isRendringComplete && !this.isFixedColumnAvailable && this.rows && this.rows.length) {

      let rowHeightsObj: any = {};

      setTimeout(() => {
        _.each(this.rows, (row: any) => {
          const rowSelector = `#row_${CSS.escape(row.key)}`;
          const rowElement: any = document.querySelector(`.scrollable-column-table > .data-table > tbody > ${rowSelector}`);
          const cellSelector = `.data-table > tbody > ${rowSelector} > td > .cell-wrapper`;
          const cells: any = document.querySelectorAll(cellSelector);

          if (cells.length) {
            let cellMaxHeight: number = 0;
            cells.forEach((cell: any) => {
              const cellRect = cell.getBoundingClientRect();
              if (cellMaxHeight < cellRect.height) {
                cellMaxHeight = cellRect.height;
              }
            });
            rowHeightsObj[row.key] = `${cellMaxHeight}px`;
          }
          this.rowHeights = rowHeightsObj;
        });

        
        this.isRendringComplete = true;
      }, 500);
    }
  }



  updateRowHieght: boolean = false
  getRowHeight(row: any) {
    const dateObject: any = new Date();
    if (!this.updateRowHieght) {
      setTimeout(() => {
        this.updateRowHieght = true
      }, 300)
    }
    if (row.key && this.updateRowHieght && this.isRendringComplete) {
      const cells: any = document.querySelectorAll('.data-table >tbody > #collapse_row_' + row.key + ">td>.cell-wrapper");
      if (cells && cells.length) {
        let cellMaxHieght: number = 0;
        cells.forEach((cell: any) => {
          const cellRect: any = cell.getBoundingClientRect();
          if (cellMaxHieght < cellRect.height) {
            cellMaxHieght = cellRect.height
          }
        })
        return cellMaxHieght + 'px'
      } else {
        return ''
      }
    } else {
      return '';
    }
  }

  childLoaderWidth: string = '';
  onDrillDownClick(rowdata: any, rows: any) {
    if (this.tableType == 'accordion' || this.tableType == 'drilldown') {
      if (this.tableType == 'drilldown') {
        this.selecterRowKey = rowdata.key
      }


      if (rowdata.isExpanded) {
        rowdata.isExpanded = false;
        rowdata.isLoading = false;
      } else {
        rowdata.isLoading = true;
        rowdata.isExpanded = true;
        this.updateRowHieght = false;
      }
      // this code is used to show loader on exapneded table.
      // this.initChildLoader(rowdata.key)
      if (this.childLoaderWidth == '') {
        let loaderTD: any = document.getElementById(rowdata.key);
        let timeoutId = setInterval(() => {
          if (!loaderTD) {
            loaderTD = document.getElementById(rowdata.key);
          } else {
            clearInterval(timeoutId);
            this.initChildLoader(rowdata.key, loaderTD);
          }
        }, 1)
        setTimeout(() => {
          if (timeoutId) {
            clearInterval(timeoutId)
          }
        }, 300)
      }

      rows = _.map(rows, (row: any) => {
        // if (row.key == rowdata.key) {
        //   if (rowdata.isExpanded) {
        //     row.isExpanded = false;
        //     rowdata.isExpanded = false;
        //   } else {
        //     row.isExpanded = true;
        //     rowdata.isExpanded = true;
        //   }
        // } else 
        if (row.key != rowdata.key) {
          if (row.drillDown) {
            row.drillDown = [];
            delete row.header
            delete row.fixedHeader
          }
          delete row.isExpanded
        }
        return row;
      })
      if (this.tableType == 'accordion') {
        this.onExapnd.emit(rowdata)
      } else if (this.tableType == 'drilldown') {
        this.onDrillDown.emit(rowdata)
      }
    }
  }

  onTextClick(column: any, rowdata: any, rows: any) {
    if (column.clickable) {
      this.selecterRowKey = rowdata.key
      rows = _.map(rows, (row: any) => {
        if (row.key == rowdata.key) {
          row.selected = true;
        } else {
          delete row.selected
        }
        return row;
      })

      this.onSelect.emit(rowdata)
    }

  }

  onCheckBoxClick(rowdata: any, rows: any) {

    if (this.tableConfig.showCheckbox) {
      // if(rowdata.checked){
      //   rowdata.checked = false;
      // }else{
      //   rowdata.checked = true;
      // }
      rows = _.map(rows, (row: any) => {
        if (row.key == rowdata.key) {
          if (row.checked) {
            delete row.checked
          } else {
            row.checked = true;
          }
        }
        return row;
      })

      this.onCheck.emit(rowdata)
    }
  }
  onExapndClick(rowdata: any, rows: any) {

  }

  onEditClick(row: any, rows: any) {
    this.onEdit.emit(row)
  }
  onDeleteClick(row: any, rows: any,rowIdx:any) {
    this.delete.emit({
      index:rowIdx,
      data:row
    })
  }

  initChildLoader(rowKey, loaderTD) {
    document.querySelectorAll('.data-table-container').forEach((container: any) => {
      if (container.contains(loaderTD)) {
        const containerRect: any = container.getBoundingClientRect();
        const tdRect: any = loaderTD.getBoundingClientRect();
        let isLoaderShow: boolean = true;
        document.querySelectorAll('#loader_' + rowKey).forEach((loader: any) => {
          if (isLoaderShow) {
            loader.style.width = containerRect.width + 'px'
            this.childLoaderWidth = containerRect.width + 'px'
            // loader.style.left = tdRect.left + 'px'
            // loader.style.top = tdRect.top + 'px'
            // loader.style.paddingTop= loaderTD.style.paddingTop+'px'
            isLoaderShow = false;
          } else {
            loader.style.display = 'none'
          }
        });

      }
    })
  }

  getSortIcon(column: any): string {
    if ((this.sortColumn === column.uniqueId) || (this.sortColumn === column.sortId)) {
      return this.sortDirection === 'asc' ? 'assets/images/arrow-up.svg' : 'assets/images/arrow.svg';
    }
    return 'assets/images/arrow-up.svg';
  }

  onSort(column: any, rows: any, tableId: string) {
    const sortKey = column.sortId || column.uniqueId
    if (this.sortColumn === sortKey) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = sortKey;
      this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
    }
    this.sortTable = tableId;
    if(!this.isExternalSort){
      this.sortData(rows)
    }else{
      const columnToSort:any = Helpers.deepClone(column);
      columnToSort.sort_order = this.sortDirection;
      this.onDataSort.emit(columnToSort)
    }
   
  }

  sortData(rows: any) {
    if (this.sortColumn) {
      // Separate NA and non-NA rows
      const isNA = (row: any) => {
        const val = this.getSortableValue(row[this.sortColumn!]);
        return typeof val === 'string' && val.trim().toLowerCase() === 'na';
      };

      const nonNARows = rows.filter((row: any) => !isNA(row));
      const naRows = rows.filter((row: any) => isNA(row));

      nonNARows.sort((a, b) => {
        const valA = this.getSortableValue(a[this.sortColumn!]);
        const valB = this.getSortableValue(b[this.sortColumn!]);

        if (this.sortDirection === 'asc') {
          return this.compareValues(valA, valB);
        } else {
          return this.compareValues(valB, valA);
        }
      });

      // Concatenate non-NA rows with NA rows at the end
      rows.splice(0, rows.length, ...nonNARows, ...naRows);
    }
  }

  getSortableValue(value: any): any {
    if (value == null || value === "") return "";
    value = String(value).trim().replace(/,/g, "");
    const match = value.match(/^[-]?\d+(\.\d+)?|^[a-zA-Z ]*\d+(\.\d+)?|^[a-zA-Z0-9 ]+/);
    if (!match) return "";
    const extracted = match[0].trim();
    const num = Number(extracted);
    return !isNaN(num) && extracted !== "" ? num : extracted;
  }

  compareValues(valA: any, valB: any): number {
    // Handle "NA" (case-insensitive) to always be at the end
    const isNA = (v: any) => typeof v === 'string' && v.trim().toLowerCase() === 'na';

    if (isNA(valA) && isNA(valB)) return 0;
    if (isNA(valA)) return 1;
    if (isNA(valB)) return -1;

    if (typeof valA === 'number' && typeof valB === 'number') {
      return valA - valB;
    }
    if (typeof valA === 'string' && typeof valB === 'string') {
      return valA.localeCompare(valB);
    }
    if (typeof valA === 'number' && typeof valB === 'string') {
      return -1;
    }
    if (typeof valA === 'string' && typeof valB === 'number') {
      return 1;
    }
    return 0;
  }


  isEllipsisActive() {
    const el: any = document.querySelector('.scrollable-column-table');
    if (el) {
      return (el.offsetWidth < el.scrollWidth)
    } else {
      return false
    }
    this.cdr.detectChanges();
  }

  getTextColor(row: any, key: string) {
    if (this.tableConfig.showHeatMap && row && row.heatMapTextColor && row.heatMapTextColor[key]) {
      return row.heatMapTextColor[key]
    } else if (row && row.textColor && row.textColor[key]) {
      return row.textColor[key]
    } else {
      return ''
    }
  }
  showMoreCell: any = ''
  oldHieght: string = ''
  oldRowKey: string = ''
  isTextEllipsisActive(column: any, row: any) {
    const id = this.getEllipsisKey(column, row);
    const el = document.getElementById(id);
    if (this.showMoreCell == id) {
      return true
    } else if (el) {
      return (el.offsetHeight < el.scrollHeight)
    } else {
      return false
    }

  }

  toggleShowMore(column: any, row: any) {
    const key = this.getEllipsisKey(column, row);
    if (this.showMoreCell == key) {
      this.showMoreCell = ''
    } else {
      this.showMoreCell = key;
    }

    if (this.oldHieght != '') {
      this.rowHeights[this.oldRowKey] = this.oldHieght;
      this.oldHieght = '';
      this.oldRowKey = ''
    }

    if (this.showMoreCell && this.showMoreCell != '') {
      setTimeout(() => {
        const textEl: any = document.getElementById(key);
        const clientRect: any = textEl.getBoundingClientRect();
        this.oldHieght = this.rowHeights[row.key]
        this.oldRowKey = row.key;
        this.rowHeights[row.key] = clientRect.height + 50 + 'px';
      }, 100)
    }
  }

  checkShowMore(column: any, row: any) {
    const key = this.getEllipsisKey(column, row);
    return (this.showMoreCell == key)
  }

  getEllipsisKey(column: any, row: any) {
    let cellValue = `ellipsis_${row.key}_${column.uniqueId}_${row[column.uniqueId]}`;
    return cellValue.trim().replaceAll(' ', '_').replaceAll('.', '').replaceAll(',', '')
  }

  getPositiveValue = getPositiveDeviationValue;

  getDeviationTooltip(deviation: any): string {
    return getDeviationTooltipText(deviation, this.deviationComparisonLabel);
  }
}
